module.exports = __webpack_public_path__ + "img/tick.d017d4a8.svg";